var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Arrow---Down-Square",
    "data-name": "Iconly/Bold/Arrow---Down-Square",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Down-Square",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41306",
    "data-name": "Path 41306",
    d: "M10.031,0A3.842,3.842,0,0,1,14,4.137h0V9.856A3.844,3.844,0,0,1,10.031,14H3.962A3.839,3.839,0,0,1,0,9.856H0V4.137A3.837,3.837,0,0,1,3.962,0h6.069ZM7,3.619a.52.52,0,0,0-.525.525h0V8.589L4.746,6.853A.537.537,0,0,0,4.375,6.7.551.551,0,0,0,4,6.853a.528.528,0,0,0,0,.742H4l2.625,2.639a.542.542,0,0,0,.742,0h0L10,7.595a.528.528,0,0,0,0-.742.537.537,0,0,0-.749,0h0L7.525,8.589V4.144A.524.524,0,0,0,7,3.619Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.0254fbe9f95946fd4f2cc0e340e91875.svg";
export { ForwardRef as ReactComponent };